<script>
import { defineComponent } from 'vue'
import Spinner from './spinner.vue'

export default defineComponent({
    name: 'loadingPlaceholder',
    components: { Spinner },
    props: {
        overlay: Boolean
    }
})
</script>

<template>
    <div :class="{'overlay-mode': overlay}"
         class="loading-placeholder-container">
        <spinner class="loading-spinner" />
    </div>
</template>

<style>
.loading-placeholder-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 128px;

    animation: anim-fade-in 200ms;
}

.loading-placeholder-container.overlay-mode {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 1;
    background-color: #fff6;
}

.loading-spinner {
    width: 48px;
    height: 48px;
    color: var(--color-primary, #000A);
}
</style>
